import MembershipBusinessListPagingResultModelBase from '../_generated/modelBases/membership-business-list-paging-result-model-base';

export default class MembershipBusinessListPagingResultModel extends MembershipBusinessListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
